import * as React from "react";
import { Drawer,Icon,List,Button,Input,message} from "antd";
import { connect } from "react-redux";
const Search = Input.Search;
interface ILogProps {
  number:any;
  alilog:any;
  user:any;
}

// 修改
class Log extends React.Component<ILogProps, any> {
  state = {
    initLoading: true,
    loading: false,
    data: [],
    visible:false,
    page:0,
    search:'',
  };
  constructor(props: ILogProps) {
    super(props);
  }

  onClose = () => {
    this.setState({
      visible: false,
      data: [],
      page: 0,
    });
  }; 
  showDrawer = () => {
    console.log(this.props.user);
    if(this.props.user.name != 'xuqi***'){
      message.error('没有权限');
      return;
    }
    this.setState({
      visible: true,
      search:this.props.number
    });
    this.alilog(false,this.props.number);
  };
  
  alilog(is_add=false,content='') {
    if(content == ''){
      content = this.state.search;
    }
    const param: any = {
      query: content,
      page :this.state.page
    }; 
    this.props.alilog({
      ...param,
      callback: (data) => {
        if(!is_add){
          this.setState({
            data: data
          });
        }else{
          this.setState({
            data: this.state.data.concat(data)
          });
        }
      }
     });
   }
  
   onLoadMore = () =>{
    let page = this.state.page
    this.setState({
      page: page+1,
    });
    this.alilog(true);
  }

  getItem(item){
    return (
      <List.Item>
        <List.Item.Meta
          description={item.content}
        />
      </List.Item>
    )
  }

  decodeBase64Content= (base64Content) => {
    let commonContent = base64Content.replace(/\s/g, '+');
    commonContent = Buffer.from(commonContent, 'base64').toString();
    return commonContent;
  }

  encodeBase64Content = (commonContent) => {
    let base64Content = Buffer.from(commonContent).toString('base64');
    return base64Content;
  }


  search = (value) =>{
    this.setState({
      search:this.encodeBase64Content(value),
      data:[],
      page:0,
    });  
    this.alilog(true,this.encodeBase64Content(value));  
  }

  render() {
    const { data } = this.state;
    const loadMore = (
       <div style={{textAlign: 'center', marginTop: 12, height: 32, lineHeight: '32px'}}>
        <Button onClick={this.onLoadMore}>loading more</Button>
      </div>);
    return (
      <React.Fragment>
        <a><Icon onClick={this.showDrawer} type="aliyun" style={{ fontSize: '18px',marginLeft:'10px' }}  /></a>
         <Drawer title="日志信息" width={720} placement="right" closable={false} onClose={this.onClose} visible={this.state.visible}>
         <Search enterButton="Search" defaultValue={this.decodeBase64Content(this.state.search)} size="large" onSearch={this.search}/>
         <br/><br/>
         <List loadMore={loadMore} className="demo-loadmore-list"  itemLayout="horizontal" renderItem={this.getItem}  dataSource={data} />
        </Drawer>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  number: state.orderDetails.number,
  user: state.userInfo.user,
});

const mapDispatch = dispatch => {
  return {
    alilog: dispatch.orderDetails.alilog
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Log);
